import React, { useMemo, useState } from 'react';
import { Card, Col, Row, Button, Modal } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';

const QuotationTracking = () => {
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showViewModal, setViewShowModal] = useState(false);
    const [quotationsModal, setQuotationsModal] = useState(false)

    const columns = useMemo(
        () => [
            {
                Header: "Quotation No.",
                accessor: "quotationNo",
            },
            {
                Header: "Inquiry No.",
                accessor: "inquiryNo",
            },
            {
                Header: "Client Name",
                accessor: "clientName",
            },
            {
                Header: "Propesal Amount",
                accessor: "propesalAmount",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "Created Date",
                accessor: "createdDate",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true, // Disable sorting for action column
            },
        ],
        []
    );

    const data = useMemo(
        () => [
            {
                id: 1,
                quotationNo: 'QT-2023-001',
                inquiryNo: '123',
                clientName: 'XYZ Corp',
                propesalAmount: '15,000',
                status: 'Pending',
                createdDate: '12/05/2023',
            },
            {
                id: 2,
                quotationNo: 'QT.2023-002',
                inquiryNo: '658',
                clientName: 'Bill. Inc.',
                propesalAmount: '15,000',
                status: 'Declined',
                createdDate: '12/05/2023',
            },
            {
                id: 3,
                quotationNo: 'QT.2023. 003',
                inquiryNo: '456',
                clientName: 'Pror. Inc.',
                propesalAmount: '15,000',
                status: 'Approved',
                createdDate: '12/05/2023',
            },

        ],
        []
    );

    const actions = ['edit', 'delete', 'Send Quotations']
    const subActions = []

    const initialValues = {
        id: '',
        quotationNo: '',
        clientName: '',
        propesalAmount: '',
        status: '',
        createdDate: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            //setLoadings(true);
            let postData = {
                leadName: values.leadName,
                clientType: values.clientType,
                stage: values.stage,
                source: values.source,
                assignee: values.assignee,
            }

            console.log(postData);
            setShowModal(false);

            // const formData = new FormData();
            // formData.append('leadName', values.leadName);
            // formData.append('clientType', values.clientType);
            // formData.append('stage', values.stage);
            // formData.append('source', values.source);
            // formData.append('assignee', values.assignee);

            // try {
            //     const res = await postGeneralForms(postData);
            //     toast.success(res.data.message);
            //     setLoadings(false);
            //     setShowModal(false);

            // } catch (error) {
            //     setLoadings(false);
            //     toast.error(error.response?.data?.message || "Error submitting data");
            // }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleConfirm = () => {
        setShowModal(false);
        formik.resetForm();
    };

    const handleEdit = (rowData) => {
        setFieldValue('id', rowData.id);
        setFieldValue('quotationNo', rowData.quotationNo);
        setFieldValue('clientName', rowData.clientName);
        setFieldValue('propesalAmount', rowData.propesalAmount);


        setViewShowModal(true);
    };

    const handleDelete = (rowData) => {
        console.log('Updating row:', rowData);
    };

    const handleSendQuotations = (rowData) => {
        setQuotationsModal(true);
    }

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            <PageTitle titles="Quotations" active="Quotations" items={['Home']} />

            <Row>
                <Col sm={12} className="col-12">
                    <Card>
                        <Card.Body className="example1-table">
                            <div className='custompageHed'>
                                <Row>
                                    <Col md={6}>
                                        <div className='pagetitle_hed'>
                                            <h1>Quotations</h1>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='w-100 d-flex justify-content-end'>
                                            <Button
                                                variant="primary"
                                                onClick={() => setShowModal(true)}
                                            >
                                                Add New
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <Tables
                                columns={columns}
                                data={data}
                                actions={actions}
                                subActions={subActions}
                                onEdit={handleEdit}
                                onDelete={handleDelete}
                                onSendQuotations={handleSendQuotations}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Modals
                show={showModal}
                handleClose={() => setShowModal(false)}
                title="Create New Quatation"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Lead Name</label>
                                <input
                                    type='text'
                                    id="quotationNo"
                                    name="quotationNo"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.quotationNo}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.quotationNo && touched.quotationNo && (
                                    <p className="errormsg">{errors.quotationNo}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Client Name</label>
                                <input
                                    type='text'
                                    id="clientName"
                                    name="clientName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.clientName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.clientName && touched.clientName && (
                                    <p className="errormsg">{errors.clientName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Propesal Amount</label>
                                <input
                                    type='text'
                                    id="propesalAmount"
                                    name="propesalAmount"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.propesalAmount}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.propesalAmount && touched.propesalAmount && (
                                    <p className="errormsg">{errors.propesalAmount}</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={showViewModal}
                handleClose={() => setViewShowModal(false)}
                title="View Quatation"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
            >
                <Row>
                    <Col md={6}>
                        <div className="form-group">
                            <label className="form-label">Lead Name</label>
                            <input
                                type='text'
                                id="quotationNo"
                                name="quotationNo"
                                className="form-control"
                                autoComplete='off'
                                value={values.quotationNo}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.quotationNo && touched.quotationNo && (
                                <p className="errormsg">{errors.quotationNo}</p>
                            )}
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="form-group">
                            <label className="form-label">Client Name</label>
                            <input
                                type='text'
                                id="clientName"
                                name="clientName"
                                className="form-control"
                                autoComplete='off'
                                value={values.clientName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.clientName && touched.clientName && (
                                <p className="errormsg">{errors.clientName}</p>
                            )}
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="form-group">
                            <label className="form-label">Propesal Amount</label>
                            <input
                                type='text'
                                id="propesalAmount"
                                name="propesalAmount"
                                className="form-control"
                                autoComplete='off'
                                value={values.propesalAmount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.propesalAmount && touched.propesalAmount && (
                                <p className="errormsg">{errors.propesalAmount}</p>
                            )}
                        </div>
                    </Col>
                </Row>
            </Modals>

            <Modals
                show={quotationsModal}
                handleClose={() => setQuotationsModal(false)}
                title="Send Quotations"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className='quatationbox'>
                        { }
                    </div>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {isLoadings || isLoading && <Loader />}
        </>
    )
}
export default QuotationTracking